import React from "react";
import { useApp } from "../../../../context/app";
import { formatDefaultValueSelect } from "../../../../utils/mask";
import styles from "./styles.module.scss";
import { sortArrayByDirection, sortByDirection } from "../../../../utils/utils";
import { Button, Grid } from "@mui/material";
import { FilterSelectAdmin } from "../../../../components/FilterSelectAdmin";


export function FiltroGerencial({
                                    filtersSelectedValues,
                                    isLoading,
                                    filterOptions,
                                    cidades,
                                    canaisDigitais,
                                    acoes,
                                    solucoes,
                                    regionais,
                                    onDataInicioChange = null,
                                    onDataFimChange = null,
                                    onMesChange = null,
                                    onAnoChange = null,
                                    onUFChange = null,
                                    onCidadeChange = null,
                                    onUserQueChange = null,
                                    onCanalChange = null,
                                    onInteracaoChange = null,
                                    onTemaChange = null,
                                    onChangeItem = () => {
                                    },
                                    updateFilters = undefined,
                                    isQtdAgente,
                                }) {
    const {filtersDashboard} = useApp();

    function handleDataInicioChange(event) {
        if (onDataInicioChange) {
            const newValue = event?.target?.value ?? event?.currentTarget?.value ?? event;
            onDataInicioChange(newValue);
        }
    }

    function handleDataFimChage(event) {
        if (onDataFimChange) {
            const newValue = event?.target?.value ?? event?.currentTarget?.value ?? event;
            onDataFimChange(newValue);
        }
    }

    function handleMesChange(event) {
        if (onMesChange) {
            const newValue = event?.target?.value ?? event?.currentTarget?.value ?? event;
            onMesChange(newValue);
        }
    }

    function handleAnoChange(event) {
        if (onAnoChange) {
            const newValue = event?.target?.value ?? event?.currentTarget?.value ?? event;
            onAnoChange(newValue);
        }
    }

    function handleUFChange(event) {
        if (onUFChange) {
            const newValue = event?.target?.value ?? event?.currentTarget?.value ?? event;
            onUFChange(newValue);
        }
    }

    function handleCidadeChange(event) {
        if (onCidadeChange) {
            const newValue = event?.target?.value ?? event?.currentTarget?.value ?? event;
            onCidadeChange(newValue);
        }
    }

    function handleTemaChange(event) {
        if (onTemaChange) {
            const newValue = event?.target?.value ?? event?.currentTarget?.value ?? event;
            const findedTema = filterOptions?.temas?.find(
                (t) => t.id.toString() === newValue
            );
            onTemaChange(findedTema);
        }
    }


    function handleUserQueChange(event) {
        if (onUserQueChange) {
            const newValue = event?.target?.value ?? event?.currentTarget?.value ?? event;
            onUserQueChange(newValue);
        }
    }


    function handleCanalChange(event) {
        if (onCanalChange) {
            const newValue = event?.target?.value ?? event?.currentTarget?.value ?? event;
            onCanalChange(newValue);
        }
    }

    function handleInteracaoChange(event) {
        if (onInteracaoChange) {
            const target = event?.target?.value ?? event?.currentTarget?.value ?? event;
            const newValue = target === "Todas" ? "" : target;
            onInteracaoChange(newValue);
        }
    }

    return (
        <Grid container spacing={2} className={styles.big_container}>
            {/* LINHA 1 */}
            <Grid container item spacing={2} className={styles.content_gerencial}>
                {/* UF */}
                <Grid item xs={2}>
                    <div>
                        <div>
                            <label htmlFor="input-uf">UF</label>
                        </div>
                        <select
                            value={
                                filtersDashboard?.ufValueSelect?.id ??
                                filtersSelectedValues?.ufs ??
                                ""
                            }
                            className="correct-color"
                            onChange={handleUFChange}
                        >
                            <option value={null}>{isLoading ? 'Carregando...' : 'Todas'}</option>
                            {sortByDirection(filterOptions?.ufs, 'sigla')
                                .map((uf) => (
                                    <option key={uf.id} value={uf.id} title={uf.sigla}>
                                        {uf.sigla}
                                    </option>
                                ))}
                        </select>
                    </div>
                </Grid>

                {/* CIDADE */}
                <Grid item xs={2}>
                    <div>
                        <div>
                            <label htmlFor="input-cidade">Cidade</label>
                        </div>
                        <select
                            value={
                                filtersDashboard?.cidadesValueSelect?.id ??
                                filtersSelectedValues?.cidades ??
                                ""
                            }
                            className="correct-color"
                            onChange={handleCidadeChange}
                        >
                            <option value={""}>{isLoading ? 'Carregando...' : 'Todas'}</option>
                            {
                                sortByDirection(cidades, 'nome').map((cidade) => (
                                    <option
                                        key={cidade.id}
                                        value={cidade.id}
                                        title={cidade.nome}
                                    >
                                        {cidade.nome}
                                    </option>
                                ))}
                        </select>
                    </div>
                </Grid>


                {/* Data Início */}
                <Grid item md={2}>
                    <div>
                        <div>
                            <label htmlFor="dataInicio">Data Inicio</label>
                        </div>
                        <input
                            disabled={
                                filtersSelectedValues?.mes || filtersSelectedValues?.ano
                            }
                            value={
                                filtersDashboard.dataInicial ??
                                filtersSelectedValues?.dataInicial ??
                                ""
                            }
                            id="dataInicio"
                            name="dataInicio"
                            type="date"
                            max={"9999-12-31"}
                            // className="date-picker"
                            onChange={handleDataInicioChange}
                        />
                    </div>
                </Grid>


                {/* Data Fim */}
                <Grid item md={2}>
                    <div>
                        <div>
                            <label htmlFor="dataFinal">Data Fim</label>
                        </div>
                        <input
                            disabled={
                                filtersSelectedValues?.mes || filtersSelectedValues?.ano
                            }
                            value={
                                filtersDashboard.dataFinal ??
                                filtersSelectedValues?.dataFinal ??
                                ""
                            }
                            id="dataFinal"
                            name="dataFinal"
                            type="date"
                            max={"9999-12-31"}
                            // className="date-picker"
                            onChange={handleDataFimChage}
                        />
                    </div>
                </Grid>

                <Grid item md={2}>
                    <div>
                        <div>
                            <label htmlFor="input-mes">Mês</label>
                        </div>
                        <select
                            id="input-mes"
                            disabled={
                                filtersSelectedValues?.dataInicial ||
                                filtersSelectedValues?.dataFinal
                            }
                            value={filtersSelectedValues?.mes ?? ""}
                            className="correct-color"
                            onChange={handleMesChange}
                        >
                            <option value={""}>Selecione</option>
                            {filterOptions?.meses &&
                                filterOptions?.meses.map((mes) => (
                                    <option key={mes} value={mes}>
                                        {formatDefaultValueSelect(mes)}
                                    </option>
                                ))}
                        </select>
                    </div>
                </Grid>

                <Grid item md={2}>
                    <div>
                        <div>
                            <label htmlFor="input-ano">Ano</label>
                        </div>
                        <select
                            disabled={
                                filtersSelectedValues?.dataInicial ||
                                filtersSelectedValues?.dataFinal
                            }
                            className="correct-color"
                            value={filtersSelectedValues?.ano ?? ""}
                            onChange={handleAnoChange}
                        >
                            <option value={""}>Selecione</option>
                            {filterOptions?.anos &&
                                filterOptions?.anos.sort().map((ano) => (
                                    <option key={ano} value={ano}>
                                        {ano}
                                    </option>
                                ))}
                        </select>
                    </div>
                </Grid>
            </Grid>
            {/* FIM LINHA 1 */}
            {/*LINHA 2*/}
            <Grid container item spacing={1} className={styles.content_gerencial}>
                <Grid item md={4}>
                    <div>
                        <div>
                            <label htmlFor="input-canal">Agente</label>
                        </div>
                        <select
                            value={filtersSelectedValues?.atendentes?.id ?? ""}
                            className="correct-color"
                            onChange={handleCanalChange}
                        >
                            <option value={null}>{isLoading ? 'Carregando...' : 'Todos'}</option>
                            {sortByDirection(filterOptions?.atendentes, 'nome').map((at, idx) => (
                                <option key={idx} value={at.id}>
                                    {formatDefaultValueSelect(at.nome)}
                                </option>
                            ))}
                        </select>
                    </div>
                </Grid>
                <Grid item md={4}>
                    <FilterSelectAdmin
                        name={"acao"}
                        optionLabel={"nomeAcao"}
                        returnAsObject={true}
                        formatLabel={(value) =>
                            value?.descricao || value?.id + " - " + value?.nomeAcao
                        }
                        label={"Ação"}
                        placeholder={isLoading ? 'Carregando...' : 'Todas'}
                        value={filtersSelectedValues?.acao}
                        options={sortByDirection(acoes, 'descricao')}
                        onChangeItem={onChangeItem}
                        styleSelectContainer={{padding: "0 0", backgroundColor: null}}
                    />
                </Grid>
                <Grid item md={4}>
                    <FilterSelectAdmin
                        name={"regionalProjetoAcao"}
                        label={"Regionais"}
                        placeholder={isLoading ? 'Carregando...' : 'Todas'}
                        value={filtersSelectedValues?.regionalProjetoAcao}
                        options={sortArrayByDirection(regionais)}
                        onChangeItem={onChangeItem}
                        styleSelectContainer={{padding: "0 0", backgroundColor: null}}
                    />
                </Grid>
            </Grid>
            {/*    FIM DA LINHA 2*/}

            {/*LINHA 3*/}
            <Grid container item spacing={1} className={styles.content_gerencial}>
                <Grid item md={3}>
                    <div>
                        <div>
                            <label htmlFor="input-interacao">Interação</label>
                        </div>
                        <select
                            value={filtersSelectedValues?.interacao ?? ""}
                            className="correct-color"
                            onChange={handleInteracaoChange}
                        >
                            <option value={null}>{isLoading ? 'Carregando...' : 'Todas'}</option>
                            {
                                sortArrayByDirection(filterOptions?.tiposInteracao).map((val, idx) => (
                                    <option key={idx} value={val}>
                                        {formatDefaultValueSelect(val)}
                                    </option>
                                ))}
                        </select>
                    </div>
                </Grid>
                <Grid item md={3}>
                    <FilterSelectAdmin
                        name={"empresaVinculada"}
                        label={"Empresa habilitada"}
                        placeholder={isLoading ? 'Carregando...' : 'Todas'}
                        value={filtersSelectedValues?.empresaVinculada}
                        options={sortArrayByDirection(filterOptions?.empresasVinculadas)}
                        onChangeItem={onChangeItem}
                        styleSelectContainer={{padding: "0 0", backgroundColor: null}}
                    />
                </Grid>
                <Grid item md={2}>
                    <FilterSelectAdmin
                        name={"visita"}
                        label={"Visita"}
                        placeholder={isLoading ? 'Carregando...' : 'Todas'}
                        formatLabel={formatDefaultValueSelect}
                        value={filtersSelectedValues?.visita}
                        options={filterOptions?.visita}
                        onChangeItem={onChangeItem}
                        styleSelectContainer={{padding: "0 0", backgroundColor: null}}
                    />
                </Grid>
                <Grid item md={2}>
                    <FilterSelectAdmin
                        name={"solucao"}
                        label={"Soluções Sebrae"}
                        placeholder={isLoading ? 'Carregando...' : 'Todas'}
                        value={filtersSelectedValues?.solucao}
                        options={solucoes}
                        onChangeItem={onChangeItem}
                        styleSelectContainer={{padding: "0 0", backgroundColor: null}}
                    />
                </Grid>
                <Grid item md={2}>
                    <FilterSelectAdmin
                        name={"canalDigital"}
                        label={"Presença digital"}
                        placeholder={isLoading ? 'Carregando...' : 'Todas'}
                        value={filtersSelectedValues?.canalDigital}
                        options={canaisDigitais}
                        onChangeItem={onChangeItem}
                        styleSelectContainer={{padding: "0 0", backgroundColor: null}}
                    />
                </Grid>
            </Grid>
            {/*    FIM DA LINHA 3*/}
            {/*LINHA 4*/}
            <Grid container item spacing={1} className={styles.content_gerencial}>
                <Grid item md={3}>
                    <div>
                        <div>
                            <label htmlFor="input-userQue">Usuários que</label>
                        </div>
                        <select
                            value={filtersSelectedValues?.usuariosQue ?? ""}
                            className="correct-color"
                            onChange={handleUserQueChange}
                        >
                            <option value={""}>{isLoading ? 'Carregando...' : 'Todos'}</option>
                            {
                                sortArrayByDirection(filterOptions?.usuariosQue).map((uq) => (
                                    <option key={uq} value={uq} title={uq}>
                                        {formatDefaultValueSelect(uq)}
                                    </option>
                                ))}
                        </select>
                    </div>
                </Grid>
                <Grid item md={4}>
                    <FilterSelectAdmin
                        name={"portes"}
                        returnAsObject={true}
                        optionLabel="sigla"
                        label={"Porte"}
                        placeholder={"Todas"}
                        value={
                            filtersSelectedValues?.portes?.length &&
                            filtersSelectedValues?.portes[0]
                        }
                        options={sortByDirection(filterOptions?.portes, "sigla")?.filter(
                            (p) => p.sigla !== "Todos"
                        )}
                        onChangeItem={(event) => onChangeItem(event, true)}
                        styleSelectContainer={{padding: "0 0", backgroundColor: null}}
                    />
                </Grid>
                {!isQtdAgente && (
                    <Grid item md={2}>
                        <div>
                            <div>
                                <label htmlFor="input-cidade">Temas</label>
                            </div>
                            <select
                                value={
                                    filtersDashboard?.tema?.id ??
                                    filtersSelectedValues?.tema?.id ??
                                    ""
                                }
                                className="correct-color"
                                onChange={handleTemaChange}
                            >
                                <option value={null}>{isLoading ? 'Carregando...' : 'Todos'}</option>
                                {
                                    sortByDirection(filterOptions?.temas, 'descricao')
                                        .map((tema) => (
                                            <option
                                                key={tema.id}
                                                value={tema.id}
                                                title={tema.descricao}
                                            >
                                                {tema.descricao}
                                            </option>
                                        ))}
                            </select>
                        </div>
                    </Grid>
                )}
            </Grid>
            {/*    FIM DA LINHA 4*/}
            <Grid container item spacing={1} className={styles.content_gerencial} justifyContent="flex-end"
                  alignItems="flex-end">
                {updateFilters && (
                    <Grid item>
                        <Button onClick={updateFilters} variant="contained">
                            Filtrar
                        </Button>
                    </Grid>
                )}
            </Grid>
        </Grid>
    )
}
